import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import router from '@/router'

let base_url = (window as any).baseurl
const service = axios.create({
  baseURL: base_url,
  timeout: 10000 * 60,
})
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Request interceptors
service.interceptors.request.use(
  (config: any) => {
    // config.headers['Content-Type'] = 'application/json';
    // if (UserModule.token) {
    //   // config.headers['X-Access-Token'] = UserModule.token
    //   //
    // }
    let params: any = window.sessionStorage.getItem("json")
    if (params) {
      config.headers.token = JSON.parse(params).data.token
    } else if (!params) {
      if (config.url != '/user/login' && config.url != '/user/registerUser') {
        router.push('/login')
        Message({
          message: '个人信息失效，请重新登录',
          type: 'warning',
        })
        return config
      }
    }
    const reqConfig = {...config}
    reqConfig.method = reqConfig.method.toLowerCase()
    if (reqConfig.method === 'post') {
      if (!reqConfig.data) {
        // 防止字段用错
        reqConfig.data = reqConfig.params || {}
      }

      // 检测是否包含文件类型, 若包含则进行 formData 封装
      let hasFile = false
      Object.keys(reqConfig.data).forEach(key => {
        if (typeof reqConfig.data[key] === 'object') {
          const item = reqConfig.data[key]
          if (item instanceof FileList || item instanceof File || item instanceof Blob) {
            hasFile = true
          }
        }
      })
      // 检测到存在文件使用 FormData 提交数据
      if (hasFile) {
        const formData = new FormData()
        Object.keys(reqConfig.data).forEach(key => {
          formData.append(key, reqConfig.data[key])
        })
        reqConfig.data = formData
      }
    }
    return reqConfig
  },
  (error: any) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // 状态码都是数字类型
    // - 200 : 获取成功
    // - 201： 创建成功
    // - 202： 修改成功
    // - 203 ： 删除成功
    // - 304 ： 重定向
    // - 401 ： 未登陆或者非法token
    // - 403 ： 权限不够
    // - 404 ： 未找到
    // - 405 ： 参数错误
    // - 500 ： 服务器内部错误
    const res = response.data
    if (res.status > 203) {
      Message({
        message: res.message || '接口请求出错',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      if (res.status !== undefined && res.status !== 200) {
        Message({
          message: res.message || '操作成功',
          type: 'success',
          duration: 5 * 1000
        })
      }
      return response.data
    }
  },
  (error) => {
    if (error.data.status == 401) {
      router.push('/login')
      Message({
        message: '个人信息失效，请重新登录',
        type: 'warning',
      })
      return error.data
    }
  }
)
declare module 'axios' {
  interface AxiosInstance {
    (config: AxiosRequestConfig): Promise<any>
  }
}
export default service
